import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import reportsCustomer from './customer';
import BusinessReports from './business';
import BusinessItems from './business-items';
import TehranReport from './business-tehran';
const Customers = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/overview`} />
            <Redirect exact from={`${match.url}/default`} to={`${match.url}/overview`} />
            <Route path={`${match.url}/customer`} component={reportsCustomer} />
            <Route exact path={`${match.url}/overview/items`} component={BusinessItems} />
            <Route exact path={`${match.url}/overview/tehran`} component={TehranReport} />
            <Route exact path={`${match.url}/people`} render={props=><BusinessReports {...props} family="people"/>}/>
            <Route exact path={`${match.url}/operators`} render={props=><BusinessReports {...props} family="operators"/>}/>
            <Route exact path={`${match.url}/overview`} component={BusinessReports} />
            <Route exact path={`${match.url}/:section(sales|customers|products|audience)`} render={({ match: old, location }) => {
                const q = new URLSearchParams(location.search); q.set('section', old.params.section);
                return <Redirect to={`${match.url}/overview?${q.toString()}`} />;
            }} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default Customers;
